import {
  Stack,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { PurchaseOrdersPermission } from "commons/enum/permission";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import { IOrderItem } from "mobx-stores/_models/orders/order-item";
import { useStores } from "mobx-stores/_root-store";
import { ProductNameAndActiveInfo } from "pages/common/product-name-and-active-info";
import { useCallback } from "react";
import { NumberText } from "share-components/atomics/number-text";
import { XButton } from "share-components/mui-wrap/button/x-button";
import { XStickyColumnCell } from "share-components/mui-wrap/table/x-sticky-column-cell";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
import { OrderCompensating, OrderStatus } from "../status";

export const OrderItemTable = observer(() => {
  const {
    orderManagement: { orderDetail },
  } = useStores();
  return (
    <XTablePagination hidePagination>
      <TableHead>
        <TableRow>
          <XStickyColumnCell left="0" rowSpan={2}>
            Tên hàng
          </XStickyColumnCell>
          <XStickyColumnCell rowSpan={2} left="200px">
            Mã hàng
          </XStickyColumnCell>
          <XStickyColumnCell left="350px" rowSpan={2}>
            Mã vạch
          </XStickyColumnCell>
          <TableCell rowSpan={2}>ĐVT</TableCell>
          <TableCell rowSpan={2}>Ngày giao</TableCell>
          <TableCell rowSpan={2}>Đơn giá</TableCell>
          <TableCell colSpan={3} align="center">
            Số lượng đặt
          </TableCell>
          <TableCell colSpan={5} align="center">
            Quản lý đơn hàng
          </TableCell>
          <TableCell rowSpan={2}></TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Trên</TableCell>
          <TableCell>Chuẩn</TableCell>
          <TableCell>Dưới</TableCell>
          <TableCell>Trạng thái</TableCell>
          <TableCell>Tổng SL đã giao</TableCell>
          <TableCell>Bù hàng</TableCell>
          <TableCell>SL bù</TableCell>
          <TableCell>Lý do bù</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {orderDetail?.items.map((x, i) => (
          <Row data-id={x.id} key={x.id} orderItem={x}></Row>
        ))}
      </TableBody>
    </XTablePagination>
  );
});

type RowProps = {
  orderItem: IOrderItem;
};
const Row = observer(({ orderItem }: RowProps) => {
  const {
    orderManagement: { setProp },
  } = useStores();

  const onUpdateOrderStatusHandler = useCallback(() => {
    setProp("openManageStatus", true);
    setProp("selectedOrderItem", cloneDeep(orderItem));
  }, [orderItem, setProp]);

  // const updatePriceHandler = useCallback(() => {
  //   setProp("openEditPrice", true);
  //   setProp("selectedOrderItem", cloneDeep(orderItem));
  // }, [orderItem, setProp]);

  return (
    <TableRow>
      <XStickyColumnCell left="0" sx={{ minWidth: "200px" }}>
        {orderItem?.product && (
          <ProductNameAndActiveInfo
            product={orderItem?.product}
          ></ProductNameAndActiveInfo>
        )}
      </XStickyColumnCell>
      <XStickyColumnCell sx={{ minWidth: "150px" }} left="200px">
        {orderItem?.product?.code || ""}
      </XStickyColumnCell>
      <XStickyColumnCell left="350px" sx={{ minWidth: "150px" }}>
        {orderItem?.product?.barcode || ""}
      </XStickyColumnCell>
      <TableCell sx={{ minWidth: "100px" }}>
        {orderItem?.product?.unitOfCalculation || ""}
      </TableCell>
      <TableCell>{dateTimeDisplay(orderItem?.deliveryDate || "")}</TableCell>
      <TableCell sx={{ minWidth: "80px" }}>
        {orderItem?.unitPrice != null ? (
          <NumberText value={orderItem?.unitPrice}></NumberText>
        ) : (
          "*****"
        )}
      </TableCell>
      <TableCell sx={{ minWidth: "80px" }}>
        <NumberText value={orderItem?.quantityUpper}></NumberText>
      </TableCell>
      <TableCell sx={{ minWidth: "80px" }}>
        <NumberText value={orderItem?.quantityStandard}></NumberText>
      </TableCell>
      <TableCell sx={{ minWidth: "80px" }}>
        <NumberText value={orderItem?.quantityLower}></NumberText>
      </TableCell>
      <TableCell sx={{ minWidth: "120px" }}>
        {orderItem?.status && (
          <OrderStatus status={orderItem?.status}></OrderStatus>
        )}
      </TableCell>
      <TableCell sx={{ minWidth: "80px" }}>
        <NumberText value={orderItem?.deliveredQuantity}></NumberText>
      </TableCell>
      <TableCell sx={{ minWidth: "80px" }}>
        <OrderCompensating
          isCompensating={orderItem?.isCompensating || false}
        ></OrderCompensating>
      </TableCell>
      <TableCell sx={{ minWidth: "80px" }}>
        <NumberText value={orderItem?.compensatingQuantity}></NumberText>
      </TableCell>

      <TableCell sx={{ minWidth: "80px" }}>
        {orderItem?.compensatingReason || ""}
      </TableCell>
      <TableCell sx={{ minWidth: "180px" }} align="center">
        <Stack direction="row" alignItems={"center"} spacing={1}>
          <XButton
            size="small"
            accessPermission={[PurchaseOrdersPermission.ManageItem]}
            variant="contained"
            onClick={onUpdateOrderStatusHandler}
            sx={{ width: "140px" }}
          >
            Cập nhật trạng thái
          </XButton>
          {/* {allowViewAndUpdatePrice && (
            <XButton
              size="small"
              variant="contained"
              onClick={updatePriceHandler}
              sx={{ width: "120px" }}
            >
              Sửa đơn giá
            </XButton>
          )} */}
        </Stack>
      </TableCell>
    </TableRow>
  );
});
